import * as React from 'react';
import { rem } from 'polished';
import { styled } from '../themeContext';

interface NavigationBarProps {
  rightChildren?: React.ReactElement;
  className?: string;
  transparent?: boolean;
}

const Container = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: `${rem(12)} 0`,
  [props.theme.media['sm']]: {
    padding: `${rem(24)} 0`,
  },
}));

const _ContentBox = styled.div({
  padding: `0 ${rem(10)}`,
  margin: '0 auto',
});

const ContentBox = styled(_ContentBox)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
});

const MenuWrapper = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
});

const NavigationBar: React.FC<NavigationBarProps> = ({
  rightChildren,
  className,
  transparent = false,
}) => {
  return (
    <Container
      className={className}
      css={transparent
        ? { background: 'transparent' }
        : undefined
      }
    >
      <ContentBox>
        <MenuWrapper />
        <MenuWrapper>
          {rightChildren}
        </MenuWrapper>
      </ContentBox>
    </Container>
  );
};

export default NavigationBar;
